import React from 'react';
import { 
  Bed, 
  Bath, 
  Users, 
  Wifi, 
  Utensils, 
  Waves, 
  Tent, 
  Home, 
  MapPin, 
  Navigation 
} from 'lucide-react';

const Facilities = () => {
  const mainFacilities = [
    { icon: <Bed />, title: "3 Kamar Tidur", desc: "Kamar nyaman dengan penataan modern untuk istirahat maksimal." },
    { icon: <Bath />, title: "4 Kamar Mandi", desc: "Fasilitas kamar mandi bersih yang mencukupi untuk seluruh tamu." },
    { icon: <Users />, title: "Ruang Keluarga", desc: "Area berkumpul yang luas untuk menciptakan momen bersama keluarga." },
    { icon: <Wifi />, title: "Free WiFi", desc: "Koneksi internet gratis untuk tetap terhubung selama liburan." },
    { icon: <Utensils />, title: "Dapur", desc: "Dapur lengkap dengan peralatan masak untuk kebutuhan makan bersama." },
    { icon: <Waves />, title: "Kolam Renang", desc: "Nikmati kesegaran berenang dengan udara sejuk khas Malino." },
    { icon: <Tent />, title: "Ekstra Bed & Tenda", desc: "Tersedia fasilitas tambahan bagi rombongan besar atau pengalaman camping." },
    { icon: <Home />, title: "Gazebo", desc: "Tempat bersantai outdoor untuk menikmati pemandangan sawah dan kabut." },
  ];

  const nearbyAttractions = [
    { distance: "500m", name: "Kampoeng Eropa" },
    { distance: "600m", name: "The River" },
    { distance: "2km", name: "Hutan Pinus" },
    { distance: "5km", name: "Malino Highlands" },
    { distance: "8km", name: "Sierra Sky View" },
  ];

  return (
    <div className="bg-white font-poppins min-h-screen">
      {/* SECTION 1: HEADER & FASILITAS UTAMA */}
      <section className="py-20 px-6 lg:px-24">
        <div className="text-center mb-16">
          <h2 className="text-red-600 font-bold tracking-[0.3em] uppercase text-sm mb-4">Difa BallaEja Experience</h2>
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-gray-900 mb-6">Fasilitas <span className="italic font-light">Lengkap</span></h1>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-8"></div>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Menghadirkan kenyamanan rumah di tengah keindahan Batu Lapisi Malino. 
            Muat hingga <span className="font-bold text-gray-800">15-20 Orang</span>.
          </p>
        </div>

        {/* Grid Fasilitas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {mainFacilities.map((f, index) => (
            <div key={index} className="flex flex-col items-center text-center p-6 border border-gray-50 hover:border-red-600 transition-all group shadow-sm hover:shadow-xl">
              <div className="text-red-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                {React.cloneElement(f.icon, { size: 32 })}
              </div>
              <h3 className="font-bold text-gray-800 text-sm md:text-base uppercase tracking-tight mb-2">{f.title}</h3>
              <p className="text-xs text-gray-400 leading-relaxed hidden md:block">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SECTION 2: WISATA TERDEKAT & LOKASI (Dari Poster) */}
      <section className="bg-gray-50 py-20 px-6 lg:px-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16">
          
          {/* List Wisata */}
          <div className="lg:w-1/2">
            <div className="flex items-center space-x-4 mb-8">
              <div className="p-3 bg-red-600 text-white"><Navigation size={24} /></div>
              <h2 className="text-3xl font-serif font-bold">Wisata Terdekat</h2>
            </div>
            <div className="space-y-6">
              {nearbyAttractions.map((place, i) => (
                <div key={i} className="flex items-center justify-between border-b border-gray-200 pb-4 group">
                  <span className="text-gray-500 font-medium group-hover:text-red-600 transition-colors">{place.name}</span>
                  <span className="bg-white px-4 py-1 rounded-full text-xs font-bold shadow-sm border border-gray-100">{place.distance}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Info Lokasi */}
          <div className="lg:w-1/2 bg-gray-900 p-10 text-white flex flex-col justify-center relative overflow-hidden">
            <div className="relative z-10">
              <MapPin className="text-red-600 mb-6" size={40} />
              <h3 className="text-3xl font-serif font-bold mb-4">Lokasi Kami</h3>
              <p className="text-gray-400 leading-relaxed mb-8">
                Batu Lapisi Malino, <br />
                Kab. Gowa, Sulawesi Selatan.
              </p>
              <a 
                href="https://maps.app.goo.gl/seosrZMX5g4zT81W7?g_st=ipc" 
                target="_blank" 
                rel="noreferrer"
                className="inline-block bg-red-600 hover:bg-white hover:text-red-600 text-white px-8 py-3 font-bold tracking-widest transition-all text-sm"
              >
                PETUNJUK JALAN
              </a>
            </div>
            <div className="absolute -right-10 -bottom-10 opacity-10">
              <Navigation size={200} />
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Facilities;